// extracted by mini-css-extract-plugin
export default {"gallery":"ImagePreview_gallery__IW318"};